import { RoutersTable } from '../components/index.js';

const Routers = () => {
  return <RoutersTable />;
};

export default Routers;
